import styled, { css } from "styled-components";

const Img = styled.img`
  width: ${({ width }) => (width ? width + "px" : "auto")};
  height: ${({ height }) => (height ? height + "px" : "auto")};
  /* just avoiding errors */
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  ${({ round }) =>
    round &&
    css`
      border-radius: 50%;
    `}
`;

const FontIcon = styled.div`
  margin-left: ${({ marginLeft }) => marginLeft};
  /* give fontsize in pixel */
  font-size: ${({ fontSize }) => fontSize};
  color: ${({ color }) => color};
`;

export { Img, FontIcon };
